import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate, formatData } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';

const InventoryAuditDetails = (props) => {
    const audit = props.data;

    return (
        audit.lotNumber ? (
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '10px' }}>
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r truncate">{audit.lotNumber}</span>
                                        <label className="active" htmlFor="lot"> {translate('inventory:lot')}</label>
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <span className="field f-1r truncate">{audit.lotItemNumber}</span>
                                        <label className="active" htmlFor="inventoryNote"> {translate('inventory:inventoryNote')}</label>
                                    </div>
                                </div>
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r truncate">{audit.partnumberCode}</span>
                                    <label className="active" htmlFor="partNumber">{translate('inventory:partNumber')}</label>
                                </div>
                                <div className="input-field no-padding col s5">
                                    <span className="field f-1r truncate">{audit.cim}</span>
                                    <label className="active" htmlFor="cim">{translate('inventory:general.cim')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{audit.partnumberDescription}</span>
                                    <label className="active" htmlFor="partNumberDescription">{translate('inventory:partNumberDescription')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{audit.location}</span>
                                    <label className="active" htmlFor="location">{translate('inventory:location')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{audit.lastReadingQuantity}</span>
                                    <label className="active" htmlFor="quantity">{translate('inventory:quantity')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{audit.lastReadingBy}</span>
                                    <label className="active" htmlFor="user">{translate('general.user')}</label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{formatData(audit.lastReadingOn)}</span>
                                    <label className="active" htmlFor="data">{translate('inventory:general.date')}</label>
                                </div>
                                <div>
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r truncate">{audit.validationCode}</span>
                                        <label className="active" htmlFor="validationCode">{translate('inventory:qrcode')}</label>
                                    </div>
                                    <div className="title">
                                        {
                                            audit.LastReadingOrigin === ENUMS.eInventoryOriginCount.Drone.value ? (
                                                <i className="mdi mdi-quadcopter" />
                                            ) : (
                                                <i className="mdi mdi-cellphone-android" />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        ) : null
    );
};

export default withRouter(withTranslation()(InventoryAuditDetails));